CUSTOM_FIELDS_ID = require 'data/custom-fields-id'
LEGACY_POWER_UPS = require 'data/legacy-power-ups'

categories = [
  'analytics-reporting'
  'automation'
  'board-utilities'
  'communication-collaboration'
  'developer-tools'
  'file-management'
  'hr-operations'
  'it-project-management'
  'marketing-social-media'
  'product-design'
  'sales-support'
]

atlassianPowerUps = [
  '588a331cc86ffbe08f5d2c67' # Bitbucket Cloud
]

module.exports = {
  categories
  atlassianPowerUps
}



// WEBPACK FOOTER //
// ./app/scripts/data/directory.coffee